var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Result } from '@restless/sanitizers';
var SanitizeError = /** @class */ (function (_super) {
    __extends(SanitizeError, _super);
    function SanitizeError(errors) {
        var _this = _super.call(this, 'Sanitize failed') || this;
        _this.errors = errors;
        Object.setPrototypeOf(_this, SanitizeError.prototype);
        return _this;
    }
    return SanitizeError;
}(Error));
export { SanitizeError };
export var sanitize = function (schema) {
    return function (data, req) {
        var sanitized = {};
        var errors = [];
        for (var key in schema) {
            if (Object.hasOwnProperty.call(schema, key)) {
                var result = req.params[key] !== undefined
                    ? schema[key](req.params[key], "params." + key)
                    : schema[key](req[key], key);
                if (Result.isOk(result)) {
                    sanitized[key] = result.ok;
                }
                else {
                    errors.push.apply(errors, result.error);
                }
            }
        }
        if (errors.length > 0) {
            throw new SanitizeError(errors);
        }
        return sanitized;
    };
};
